var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOutNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m96 480h64c17.7 0 32-14.3 32-32s-14.3-32-32-32h-64c-17.67 0-32-14.33-32-32v-256c0-17.67 14.33-32 32-32h64c17.7 0 32-14.33 32-32s-14.3-32-32-32h-64c-53.02 0-96 42.98-96 96v256c0 53 42.98 96 96 96zm408.8-241.5-144.1-136c-6.975-6.578-17.2-8.375-26-4.594-8.803 3.797-14.51 12.47-14.51 22.05l-.0918 72-128-.001c-17.69 0-32.02 14.33-32.02 32v64c0 17.67 14.34 32 32.02 32l128 .001.0918 71.1c0 9.578 5.707 18.25 14.51 22.05 8.803 3.781 19.03 1.984 26-4.594l144.1-136c9.6-8.112 9.6-24.912 0-34.012z",
    fill: "#c4c4c4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutNew);
export default __webpack_public_path__ + "static/media/log-out-new.dcda467504ff4389130b77de463d2768.svg";
export { ForwardRef as ReactComponent };